import React, { useCallback } from 'react';

import { IconsEnum } from '../../../../../../../assets/icons/types';
import { ProductsIndexTableRowAiSearchButtonProduct } from './ProductsIndexTableRowAiSearchButton.types';
import { OnProductAiSearchAction } from '../../../../../productsTypes';
import { GADataType } from '../../../../../../../types';

import { PureIconButtonHelper } from '../../../../../../../helpers/buttons/PureIconButtonHelper';

import { aiSearchKeys } from '../../../../../../../locales/keys';

interface ProductsIndexTableRowAiSearchButtonProps {
  product: ProductsIndexTableRowAiSearchButtonProduct;
  onProductAiSearch?: OnProductAiSearchAction;
}

function ProductsIndexTableRowAiSearchButton({
  dataGa,
  product,
  onProductAiSearch
}: ProductsIndexTableRowAiSearchButtonProps & GADataType) {
  const handleProductAiSearch = useCallback<() => void>(() => {
    onProductAiSearch?.(product.id);
  }, [product, onProductAiSearch]);

  return (
    <PureIconButtonHelper
      dataGa={dataGa}
      i18nText={aiSearchKeys.findAlternatives}
      icon={IconsEnum.SEARCH_AI_OUTLINE}
      iconClassName="h-5 w-5 mr-2"
      className="flex text-left dark:hover:bg-gray-800 hover:bg-gray-100 px-4 py-2 text-sm w-full whitespace-nowrap"
      onClick={handleProductAiSearch}
    />
  );
}

export default ProductsIndexTableRowAiSearchButton;
